import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import GlobalFeedback from "./components/GlobalFeedback";
import Home from "./pages/Home";
import ReviewerAssigner from "./pages/ReviewerAssigner";
import DataOperatorUpload from "./pages/DataOperatorUpload";
import Review from "./pages/Review";
import UploadQuestionPapers from "./pages/UploadQuestionPapers";
import AutomatedEvaluation from "./pages/AutomatedEvaluation";
import PartitionReview from './pages/PartitionReview';
import AnalyzeQuestionPapers from "./pages/AnalyzeQuestionPapers";
import RubricManagement from './pages/RubricManagement';
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import "./styles/App.css";
import ProtectedRoute from './middlewares/routeprotection';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />

          {/* Protected */}
          <Route
            path="/assigner_page"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin', 'qprs_admin', 'qprs_hog']}>
                <ReviewerAssigner />
              </ProtectedRoute>
            }
          />

          <Route
            path="/data_operator_upload"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin','qprs_admin','qprs_data_operator', 'qprs_hog']}>
                <DataOperatorUpload />
              </ProtectedRoute>
            }
          />

          <Route
            path="/review_page"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin','qprs_admin','qprs_reviewer']}>
                <Review />
              </ProtectedRoute>
            }
          />

          <Route
            path="/upload_page"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin','qprs_admin', 'qprs_data_operator']}>
                <UploadQuestionPapers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/automated_evaluation"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin','qprs_admin', 'qprs_data_operator']}>
                <AutomatedEvaluation />
              </ProtectedRoute>
            }
          />

          <Route
            path="/partition-review"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin','qprs_admin', 'qprs_data_operator']}>
                <PartitionReview />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analyze_page"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin','qprs_admin','qprs_reviewer']}>
                <AnalyzeQuestionPapers />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin', 'qprs_admin','qprs_leadership']}>
                <AnalyticsDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/rubric_management"
            element={
              <ProtectedRoute allowedRoles={['qprs_super_admin', 'qprs_admin']}>
                <RubricManagement />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
      <GlobalFeedback />
    </div>
  );
}

export default App;
